import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ButtonModule } from '@progress/kendo-angular-buttons';
import { ChartModule } from '@progress/kendo-angular-charts';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { DialogModule } from '@progress/kendo-angular-dialog';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { ExcelModule, GridModule } from '@progress/kendo-angular-grid';
import { IconsModule } from '@progress/kendo-angular-icons';
import { LoaderModule } from '@progress/kendo-angular-indicators';
import { InputsModule, TextBoxModule } from '@progress/kendo-angular-inputs';
import { LabelModule } from '@progress/kendo-angular-label';
import { NotificationModule } from '@progress/kendo-angular-notification';
import { RippleModule } from '@progress/kendo-angular-ripple';
import { TooltipModule } from '@progress/kendo-angular-tooltip';
import { UploadModule } from '@progress/kendo-angular-upload';
import { OnboardingSharedModule } from 'src/app/shared/onboarding/onboarding-shared.module';
import { CommonSharedModule } from '../common/common-shared.module';
import { FileDropZoneComponent } from './dropzones/file-drop-zone/file-drop-zone.component';
import { FileDropzoneWithListComponent } from './dropzones/file-dropzone-with-list/file-dropzone-with-list.component';
import { FileUploadComponent } from './dropzones/file-upload/file-upload.component';
import { CustomerPortfolioTableComponent } from './grids/customer-portfolio-table/customer-portfolio-table.component';
import { CustomerSummaryTableComponent } from './grids/customer-summary-table/customer-summary-table.component';
import { DocumentUploadSummaryComponent } from './grids/document-upload-summary/document-upload-summary.component';
import { DocumentUploadTableComponent } from './grids/document-upload-table/document-upload-table.component';
import { KendoCheckboxGroupComponent } from './inputs/kendo-checkbox-group/kendo-checkbox-group.component';
import { KendoDropdownComponent } from './inputs/kendo-dropdown/kendo-dropdown.component';
import { KendoGroupTextboxComponent } from './text/kendo-group-textbox/kendo-group-textbox.component';
import { KendoMaskedTextboxComponent } from './text/kendo-masked-textbox/kendo-masked-textbox.component';
import { KendoPasswordTextboxComponent } from './text/kendo-password-textbox/kendo-password-textbox.component';
import { KendoTextareaComponent } from './text/kendo-textarea/kendo-textarea.component';
import { KendoTextboxComponent } from './text/kendo-textbox/kendo-textbox.component';

const components = [
  FileDropZoneComponent,
  KendoTextboxComponent,
  KendoGroupTextboxComponent,
  KendoDropdownComponent,
  CustomerPortfolioTableComponent,
  CustomerSummaryTableComponent,
  KendoPasswordTextboxComponent,
  KendoMaskedTextboxComponent,
  FileDropzoneWithListComponent,
  KendoCheckboxGroupComponent,
  KendoTextareaComponent,
  DocumentUploadTableComponent,
  DocumentUploadSummaryComponent,
  CustomerSummaryTableComponent,
  FileUploadComponent,
];

const modules = [
  CommonModule,
  CommonSharedModule,
  ButtonModule,
  ChartModule,
  DropDownsModule,
  DateInputsModule,
  GridModule,
  ExcelModule,
  InputsModule,
  TextBoxModule,
  LabelModule,
  UploadModule,
  LoaderModule,
  NotificationModule,
  RippleModule,
  IconsModule,
  OnboardingSharedModule,
  TooltipModule,
  DialogModule,
];

@NgModule({
  declarations: [...components],
  imports: [...modules],
  exports: [...components, ...modules],
})
export class KendoModule {}
